import React from 'react';
import { Row, Col, Modal, ModalBody, ModalFooter } from 'reactstrap';
import NumberFormat from 'react-number-format';

export default function ServicerCancellationModal({ isOpen, toggle, centered, profileModel, contract }) {
    const dealerContactInfo = contract?.dealerContactInformation;
    const sellingDealerName = dealerContactInfo?.sellingDealerName ?? profileModel.dealerName ?? '';
    const sellingDealerPhone = dealerContactInfo?.sellingDealerPhone ?? profileModel?.companyPhone ?? '';

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            centered={centered}
            size='lg'
        >
            <ModalBody>
                <Row>
                    <Col>
                        To cancel this contract, please direct the customer to contact {sellingDealerName} at{' '}
                        <NumberFormat
                            format='(###) ###-####'
                            value={sellingDealerPhone}
                            displayType='text'
                        />
                        .
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <button
                    className='btn-primary'
                    onClick={toggle}
                >
                    Close
                </button>
            </ModalFooter>
        </Modal>
    );
}
